// extracted by mini-css-extract-plugin
export default {"ideationInner":"Ideation_ideationInner__Jc5hh","siteTabs":"Ideation_siteTabs__TDJSu","ideationTabContane":"Ideation_ideationTabContane__-S5g0"};